import axios from '../axios';

export const getTags = (params: Paths.Tags.Get.QueryParameters) =>
    axios<BULLZ.GetTagsResponseApiResponse>({
        url: '/tags',
        method: 'GET',
        params
    });
